import { OktaAuth } from '@okta/okta-auth-js';

const OKTA_DOMAIN = process.env.REACT_APP_OKTA_DOMAIN;
const OKTA_CLIENT_ID = process.env.REACT_APP_OKTA_CLIENT_ID;
const OKTA_REDIRECT_URI = process.env.REACT_APP_OKTA_REDIRECT_URI || `${window.location.origin}/login/callback`;
const OKTA_POST_LOGOUT_REDIRECT_URI = process.env.REACT_APP_OKTA_POST_LOGOUT_REDIRECT_URI || window.location.origin;

if (!OKTA_DOMAIN || !OKTA_CLIENT_ID) {
  throw new Error(
    'Missing Okta configuration. Please set REACT_APP_OKTA_DOMAIN and REACT_APP_OKTA_CLIENT_ID in your .env file. See OKTA_SETUP.md for setup instructions.'
  );
}

export const oktaAuth = new OktaAuth({
  issuer: `https://${OKTA_DOMAIN}`,
  clientId: OKTA_CLIENT_ID,
  redirectUri: OKTA_REDIRECT_URI,
  postLogoutRedirectUri: OKTA_POST_LOGOUT_REDIRECT_URI,
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
  tokenManager: {
    autoRenew: true,
  },
});

